import $axios from "axios";
import * as Uri from "../config/uri";

export function linkInfo(params) {
  return $axios.get(Uri.linkInfo, { params });
}

export function authCode(params) {
  return $axios.post(Uri.authCode, params);
}

export function validCode(params) {
  return $axios.post(Uri.validCode, params);
}

export function protocol(params) {
  return $axios.post(Uri.protocol, params);
}

export function authInfoValid(params) {
  return $axios.post(Uri.authInfoValid, params);
}

export function authInfoInvalid(params) {
  return $axios.post(Uri.authInfoInvalid, params);
}

export function authAgree(params) {
  return $axios.post(Uri.authAgree, params);
}

export function authRefuse(params) {
  return $axios.post(Uri.authRefuse, params);
}

export function cancelAuth(params) {
  return $axios.post(Uri.cancelAuth, params);
}

export function authInvalidCode(params) {
  return $axios.get(Uri.authInvalidCode, { params });
}

export function authInvalidCodeCheck(params) {
  return $axios.post(Uri.authInvalidCodeCheck, params);
}
